<template>
	<div class="page-main" ref="scrollDom">
		<nav-bar :border="false" :left-arrow="true" title="支付" @click-left="back"></nav-bar>

		<div class="pay-content">
			<div class="qr-card">
				<vue-qr :text="'http://152.136.208.177/tradePay?orderid='+info.orderId" :size="250"
					v-clipboard:error="onError" v-clipboard:copy="'http://152.136.208.177/tradePay?orderid='+info.orderId"
					v-clipboard:success="onCopy"></vue-qr>
				<p>请用支付宝扫描二维码完成支付</p>
			</div>

			<div class="qr-card">
				<vue-qr :text="info.biz_content" :size="250" v-clipboard:error="onError" v-clipboard:copy="info.biz_content"
					v-clipboard:success="onCopy"></vue-qr>
				<p>请用支付宝调试器扫描二维码完成支付</p>
			</div>

			<a @click="goPay" class="pay-btn">网页付款</a>
			<a @click="goPage" class="pay-btn secondary">支付宝付款</a>
		</div>
	</div>
</template>

<script>
	import {NavBar} from "vant";
	import vueQr from "vue-qr";
	import BScroll from "@better-scroll/core";

	export default {
		components: {
			NavBar,
			vueQr,
		},
		data() {
			return {
				info: null,
			};
		},
		created() {
			var data = this.$route.query.data;
			this.info = JSON.parse(data);
			this.$nextTick(() => {
				this.leftScroll = BScroll(this.$refs["scrollDom"], {
					click: true,
				});
			});
		},
		methods: {
			onCopy() {
				this.$msg("链接已复制");
			},
			onError() {
				this.$msg("您的设备暂不支持复制");
			},
			back() {
				this.$router.back();
			},
			goPay() {
				location.href = this.info.alipay;
			},
			goPage() {
				location.href =
					"alipays://platformapi/startapp?appId=20000067&url=" +
					encodeURIComponent("http://152.136.208.177/tradePay?orderid=" + this.info.orderId);
			},
		},
	};
</script>

<style lang="scss" scoped>
.page-main {
	min-height: 100vh;
	background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

::v-deep .van-nav-bar {
	background: #fff;

	.van-nav-bar__title {
		color: #333 !important;
		font-size: 28px;
	}

	.van-icon {
		color: #333 !important;
	}
}

.pay-content {
	padding: 24px;
}

.qr-card {
	background: #fff;
	border-radius: 20px;
	padding: 32px;
	margin-bottom: 24px;
	text-align: center;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

	p {
		font-size: 24px;
		color: #606266;
		margin-top: 20px;
	}
}

.pay-btn {
	display: block;
	width: 100%;
	height: 88px;
	line-height: 88px;
	text-align: center;
	border-radius: 44px;
	font-size: 28px;
	font-weight: 600;
	text-decoration: none;
	margin-bottom: 20px;
	background: linear-gradient(135deg, #059669, #10b981);
	color: #fff;
	box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
	transition: transform 0.2s;

	&:active {
		transform: scale(0.97);
	}

	&.secondary {
		background: #fff;
		color: #059669;
		border: 2px solid #059669;
		box-shadow: none;
	}
}
</style>
